import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NavigatorService {
  constructor() {}

  async isCameraAvailability(): Promise<boolean> {
    try {
      if (!navigator.mediaDevices?.enumerateDevices) {
        console.warn('enumerateDevices() not supported.');
        return false;
      }
      const devices = await navigator.mediaDevices.enumerateDevices();
      const cameraAvailable = devices.some((device) => device.kind === 'videoinput');
      return cameraAvailable;
    } catch (error) {
      console.error('Camera not available:', error);
    }
    return false;
  }

  isTouchDevice(): boolean {
    return navigator.maxTouchPoints > 1;
  }
}
